import React, {useEffect, useState} from 'react';
import { useLocation } from 'react-router-dom';
import DiscountBar from './discountbar/DiscountBar';
import { FEATURE_FLAGS } from './config/featureFlags';
import Header from './header/header';
import Testimonial from "./testimonial/TestimonialCarousel";
import Footer from './footer/Footer';
import PricingPlans from './price/PricingPlans';
import FeatureCard from "./feature/FeatureCard";
import QASection from "./Q&A/QASection";
import PopupWindow from "./popUp/SignupWindow";
import TabComponent from "./demos/copilot/TabComponent";
import ScrollToTopButton from './buttons/scroll-to-top/index';
import DownloadSection from "./download/DownloadSection";
import VideoShowcase from "./video-showcase/VideoShowcase";
import UndetectableSection from "./undetectable/UndetectableSection";
import { CONTENT } from './config/landingPageContent';

function Home({ variant = 'default' }) {
    const [showPopup, setShowPopup] = useState(false);
    const { pathname, hash } = useLocation();

    useEffect(() => {
        const pathMap = {
            '/features': 'features',
            '/demo': 'interview-copilot',
            '/coding-assistant': 'coding-assistant',
            '/interview-copilot': 'interview-copilot',
            '/pricing': 'pricing',
            '/testimonials': 'testimonials',
            '/faqs': 'faqs',
            '/contact': 'contact',
            '/download': 'download',
            '/assistant/features': 'features',
            '/assistant/demo': 'interview-copilot',
            '/assistant/coding-assistant': 'coding-assistant',
            '/assistant/interview-copilot': 'interview-copilot',
            '/assistant/pricing': 'pricing',
            '/assistant/testimonials': 'testimonials',
            '/assistant/faqs': 'faqs',
            '/assistant/contact': 'contact',
            '/assistant/download': 'download'
        };

        const id = pathMap[pathname] || (hash ? hash.replace('#', '') : null);
        if (id) {
            const element = document.getElementById(id);
            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }
        } else if (pathname === '/' || pathname === '/assistant') {
            if (!hash) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }
    }, [pathname, hash]);

    useEffect(() => {
        if (showPopup) {
            document.body.classList.add('no-scroll');
        } else {
            document.body.classList.remove('no-scroll');
        }
        return () => {
            document.body.classList.remove('no-scroll');
        };
    }, [showPopup]);

    useEffect(() => {
        const content = CONTENT[variant] || CONTENT.default;
        document.title = content.seo.title;
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute('content', content.seo.description);
        }
    }, [variant]);

    return (
        <div className="App">
            {showPopup && <PopupWindow onClose={() => setShowPopup(false)} variant={variant}/>}
            <main className="App-main">
                <DiscountBar enabled={FEATURE_FLAGS.showDiscountBar} variant={variant} />
                <Header variant={variant}/>
                <section id="download">
                    <DownloadSection variant={variant}/>
                </section>
                <section id="coding-assistant" className="demo-section">
                    <h2 className="demo-title">Coding Assistant</h2>
                    <div className="demo-container">
                        <VideoShowcase/>
                    </div>
                </section>
                <section id="interview-copilot" className="demo-section">
                    <h2 className="demo-title">Interview Copilot</h2>
                    <div className="demo-container">
                        <TabComponent variant={variant}/>
                    </div>
                </section>
                <section id="features">
                    <FeatureCard variant={variant}/>
                </section>
                <section id="undetectable">
                    <UndetectableSection/>
                </section>
                <section id="pricing">
                    <PricingPlans variant={variant}/>
                </section>
                <section id="testimonials">
                    <Testimonial variant={variant}/>
                </section>
                <section id="faqs">
                    <QASection variant={variant}/>
                </section>
            </main>
            <section id='contact'>
                <Footer variant={variant}/>
            </section>
            <ScrollToTopButton/>
        </div>
    );
}

export default Home;
